var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"timeout":_vm.timeout,"multi-line":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v("Dismiss")])]}}])},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }